import React, { useState } from "react";
import { RiCheckLine, RiCloseLine } from "react-icons/ri";
import "./UserTypeFilter.css";

// The profileTypes values sent to the appointments filter API.
export const USER_TYPE_OPTIONS = [
  {
    value: 1,
    label: "Premium user",
    style: {
      background: "linear-gradient(to right, #A6743B, #CFA44F, #E4C780)",
    },
  },
  { value: 2, label: "HR representative", style: { background: "#FFBD2D" } },
  { value: 3, label: "QA User", style: { background: "#6A5EF5" } },
  { value: 4, label: "Sensitive user", style: { background: "#E44437BF" } },
  // Default user is 0, not 5 — it keeps the profile type's own encoding.
  { value: 0, label: "Default user", style: { background: "#979797" } },
];

// The "User type" column's person disc: its colour and tooltip per profile type.
// Same values as NavigoDashboard's own getProfileIcon / getProfileLabel.
const PROFILE_ICON_COLORS = {
  1: "#b8893f", // Premium
  2: "#f4b400", // HR
  3: "#9c8df2", // QA
  4: "#e57373", // Sensitive
};
const PROFILE_LABELS = {
  1: "Premium User",
  2: "HR Representative",
  3: "QA User",
  4: "Sensitive User",
};
export const getProfileIconColor = (type) =>
  PROFILE_ICON_COLORS[type] ?? "#9e9e9e";
export const getProfileLabel = (type) => PROFILE_LABELS[type] ?? "Default User";

const Checkbox = ({ checked }) => (
  <span className={`utf-checkbox${checked ? " utf-checked" : ""}`}>
    {checked && <RiCheckLine style={{ fontSize: "12px" }} />}
  </span>
);

/**
 * Multi-select filter for the "User type" column. Selections are local until
 * "Apply Filter" hands them back through onApply; an empty selection means the
 * profileTypes key is dropped from the request entirely.
 */
export function UserTypeFilter({ selected = [], onApply, onClose }) {
  const [values, setValues] = useState(selected);

  const allValues = USER_TYPE_OPTIONS.map((option) => option.value);
  const allSelected = values.length === allValues.length;

  const toggle = (value) =>
    setValues((prev) =>
      prev.includes(value)
        ? prev.filter((item) => item !== value)
        : [...prev, value],
    );

  return (
    <div className="utf-popup" onClick={(e) => e.stopPropagation()}>
      <div className="utf-header">
        <span className="utf-title">Filter by User Type</span>
        <button type="button" className="utf-close-btn" onClick={onClose}>
          <RiCloseLine style={{ fontSize: "16px" }} />
        </button>
      </div>
      <div className="utf-divider" />

      <div className="utf-select-all-row">
        <span
          className="utf-select-all-label"
          onClick={() => setValues(allSelected ? [] : allValues)}
        >
          <Checkbox checked={allSelected} />
          Select all
        </span>
        <button
          type="button"
          className="utf-invert-btn"
          onClick={() =>
            setValues(allValues.filter((value) => !values.includes(value)))
          }
        >
          Invert
        </button>
      </div>

      <div className="utf-options">
        {USER_TYPE_OPTIONS.map((option) => (
          <span
            key={option.value}
            className="utf-option-row"
            onClick={() => toggle(option.value)}
          >
            <Checkbox checked={values.includes(option.value)} />
            <button
              type="button"
              className="utf-option-pill"
              style={option.style}
              onClick={(e) => {
                // The row already toggles; stop the click counting twice.
                e.stopPropagation();
                toggle(option.value);
              }}
            >
              {option.label}
            </button>
          </span>
        ))}
      </div>

      <div className="utf-divider utf-divider-bottom" />
      <div className="utf-footer">
        <span className="utf-count">
          {`${values.length} of ${allValues.length} selected`}
        </span>
        <button
          type="button"
          className="utf-apply-btn"
          onClick={() => onApply(values)}
        >
          Apply Filter
        </button>
      </div>
    </div>
  );
}

export default UserTypeFilter;
